export var ICON_SIZES = {
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg'
};
export var DETAILED_ICON_SIZES = {
  sm: 'sm'
};
export var ICON_STATUS_TYPES = {
  info: 'info',
  success: 'success'
};